var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "PackGrid",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "gridId",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "giftId",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "valuable",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "lastIncreaseTime",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "expireTime",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "amount",
                    "id": 6
                }
            ]
        },
        {
            "name": "PackPropGrid",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "gridId",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "propId",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "valuable",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "lastIncreaseTime",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "expireTime",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "amount",
                    "id": 6
                }
            ]
        },
        {
            "name": "MallPropInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "id",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "goodsId",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "type",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "giftId",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "useType",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "amount",
                    "id": 6
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "timeLimit",
                    "id": 7
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "propTimeLimit",
                    "id": 8
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "createTime",
                    "id": 9
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "updateTime",
                    "id": 10
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "name",
                    "id": 11
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "intro",
                    "id": 12
                },
                {
                    "rule": "repeated",
                    "type": "MallPropResourceUrl",
                    "name": "resources",
                    "id": 13
                }
            ]
        },
        {
            "name": "MallPropResourceUrl",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "type",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "url",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "md5",
                    "id": 3
                }
            ]
        },
        {
            "name": "Mall",
            "fields": [],
            "messages": [
                {
                    "name": "GiftList",
                    "fields": [],
                    "options": {
                        "objc_class_prefix": "MallGiftList",
                        "java_package": "com.asiainno.uplive.proto"
                    },
                    "messages": [
                        {
                            "name": "Request",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "scene",
                                    "id": 1
                                }
                            ]
                        },
                        {
                            "name": "Response",
                            "fields": [
                                {
                                    "rule": "repeated",
                                    "type": "GiftInfo",
                                    "name": "gifts",
                                    "id": 1
                                },
                                {
                                    "rule": "repeated",
                                    "type": "AmountConfig",
                                    "name": "amountConfigs",
                                    "id": 2
                                }
                            ]
                        },
                        {
                            "name": "GiftInfo",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "giftId",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "name",
                                    "id": 2
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "intro",
                                    "id": 3
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "type",
                                    "id": 4
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "url",
                                    "id": 5
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "price",
                                    "id": 6
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "experience",
                                    "id": 7
                                },
                                {
                                    "rule": "optional",
                                    "type": "bool",
                                    "name": "canCombo",
                                    "id": 8
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "version",
                                    "id": 9
                                },
                                {
                                    "rule": "optional",
                                    "type": "bool",
                                    "name": "onLined",
                                    "id": 10
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "countryCode",
                                    "id": 11
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "language",
                                    "id": 12
                                },
                                {
                                    "rule": "optional",
                                    "type": "bool",
                                    "name": "needLoad",
                                    "id": 13
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "showType",
                                    "id": 14
                                },
                                {
                                    "rule": "repeated",
                                    "type": "GiftResourceInfo",
                                    "name": "resources",
                                    "id": 15
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "vipGrade",
                                    "id": 16
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "playTimes",
                                    "id": 17
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "produceType",
                                    "id": 18
                                },
                                {
                                    "rule": "optional",
                                    "type": "bool",
                                    "name": "canSendToAllUsers",
                                    "id": 19
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "timeLimit",
                                    "id": 20
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "hostBill",
                                    "id": 21
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "guardLevel",
                                    "id": 22
                                },
                                {
                                    "rule": "repeated",
                                    "type": "int32",
                                    "name": "giftIds",
                                    "id": 23,
                                    "options": {
                                        "packed": true
                                    }
                                },
                                {
                                    "rule": "optional",
                                    "type": "int64",
                                    "name": "delayTime",
                                    "id": 24
                                }
                            ]
                        },
                        {
                            "name": "GiftResourceInfo",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "type",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "url",
                                    "id": 2
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "md5",
                                    "id": 3
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "json",
                                    "id": 4
                                }
                            ]
                        },
                        {
                            "name": "AmountConfig",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "amount",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "description",
                                    "id": 2
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "effectLevel",
                                    "id": 3
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "Pack",
            "fields": [],
            "messages": [
                {
                    "name": "InfoValid",
                    "fields": [],
                    "options": {
                        "objc_class_prefix": "PackInfoValid",
                        "java_package": "com.asiainno.uplive.proto"
                    },
                    "messages": [
                        {
                            "name": "Request",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "scene",
                                    "id": 1
                                }
                            ]
                        },
                        {
                            "name": "Response",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "currentTime",
                                    "id": 1
                                },
                                {
                                    "rule": "repeated",
                                    "type": "PackGrid",
                                    "name": "grids",
                                    "id": 2
                                },
                                {
                                    "rule": "repeated",
                                    "type": "Mall.GiftList.GiftInfo",
                                    "name": "giftInfos",
                                    "id": 3
                                },
                                {
                                    "rule": "repeated",
                                    "type": "PackPropGrid",
                                    "name": "propGrids",
                                    "id": 4
                                },
                                {
                                    "rule": "repeated",
                                    "type": "MallPropInfo",
                                    "name": "propInfos",
                                    "id": 5
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
}).build();
export default _root;


// WEBPACK FOOTER //
// ./js/living/gift/packinfovalid.pb.js